export const IMPLEMENTATION_STATUS_NOT_APPLICABLE = 'not_applicable';
export const IMPLEMENTATION_STATUS_NONE = 'none';
export const IMPLEMENTATION_STATUS_PARTIAL = 'partial';
export const IMPLEMENTATION_STATUS_MOSTLY = 'mostly';
export const IMPLEMENTATION_STATUS_FULLY = 'fully';

/** Linked-measure row / list when no evaluation record exists yet */
export const EVALUATION_STATUS_NOT_EVALUATED = 'not_evaluated';

export const IMPLEMENTATION_STATUSES = [
    IMPLEMENTATION_STATUS_NOT_APPLICABLE,
    IMPLEMENTATION_STATUS_NONE,
    IMPLEMENTATION_STATUS_PARTIAL,
    IMPLEMENTATION_STATUS_MOSTLY,
    IMPLEMENTATION_STATUS_FULLY,
];

export const IMPLEMENTATION_STATUS_RANK = {
    [IMPLEMENTATION_STATUS_NOT_APPLICABLE]: 0,
    [IMPLEMENTATION_STATUS_NONE]: 1,
    [IMPLEMENTATION_STATUS_PARTIAL]: 2,
    [IMPLEMENTATION_STATUS_MOSTLY]: 3,
    [IMPLEMENTATION_STATUS_FULLY]: 4,
};

export function getImplementationStatusRank(status) {
    if (!status) return -1;
    return IMPLEMENTATION_STATUS_RANK[status] ?? -1;
}

export function getTargetStatusOptions(currentStatus) {
    if (!currentStatus) return [...IMPLEMENTATION_STATUSES];

    if (currentStatus === IMPLEMENTATION_STATUS_NOT_APPLICABLE) {
        return [IMPLEMENTATION_STATUS_NOT_APPLICABLE];
    }

    const currentRank = getImplementationStatusRank(currentStatus);
    return IMPLEMENTATION_STATUSES.filter(
        (status) => status !== IMPLEMENTATION_STATUS_NOT_APPLICABLE
            && getImplementationStatusRank(status) > currentRank,
    );
}

export function isValidTargetStatus(currentStatus, targetStatus) {
    if (!currentStatus) return targetStatus == null;

    if (currentStatus === IMPLEMENTATION_STATUS_NOT_APPLICABLE) {
        return targetStatus == null || targetStatus === IMPLEMENTATION_STATUS_NOT_APPLICABLE;
    }

    if (targetStatus == null) {
        return currentStatus === IMPLEMENTATION_STATUS_FULLY;
    }

    if (targetStatus === IMPLEMENTATION_STATUS_NOT_APPLICABLE) {
        return false;
    }

    const currentRank = getImplementationStatusRank(currentStatus);
    const targetRank = getImplementationStatusRank(targetStatus);
    return targetRank > currentRank;
}

export function isMeasureEvaluated(implementationStatus) {
    return Boolean(implementationStatus);
}

export function resolveLinkedMeasureEvaluationStatus(implementationStatus) {
    return implementationStatus || EVALUATION_STATUS_NOT_EVALUATED;
}
